import { alpha } from "@mui/material/styles";

export const ContextMenuStyle = () => ({
    zIndex: 25000,
    "& .MuiPaper-root": {
        boxShadow: `0 8px 24px ${alpha("#000", 0.15)}`,
        borderRadius: 2,
    },
    "& .MuiMenuItem-root": {
        fontSize: "0.9rem",
        py: 1,
    },
});